import { mapToArray } from "./shared/common";

/**
 * Regex pattern for validating both web URLs (http/https) and mobile custom schemes
 * Supports:
 * - Web URLs: https://example.com, http://localhost:3000, https://example.com:8080/path
 * - Mobile schemes: myapp://auth, com.trimble.app://signin/redirect, myapp+test://custompath
 */
const URL_VALIDATION_REGEX = /^(https?:\/\/[a-zA-Z0-9.-]+(:[0-9]+)?(\/.*)?|[a-zA-Z][a-zA-Z0-9+.-]*:\/\/[^\s]+)$/;

/**
 * Validates URLs supporting both web URLs (http/https) and mobile custom schemes
 * 
 * @param value - Comma-separated string of URLs to validate
 * @returns Empty string if valid, error message if invalid
 */
export const validateCallbackLogoutUrls = (value: string | undefined): string => {
  if (typeof value === "string") {
    const values = mapToArray(value.split(","));
    if (values.length > 250) {
      return "The number of urls exceed the max limit i.e. 250 ";
    }
    
    const trimmedValues = values.map((item: string) => String(item).trim()).filter((item: string) => item.length > 0);
    
    if (trimmedValues.every((item: string) => URL_VALIDATION_REGEX.test(item))) {
      return "";
    }
  }

  return "Please enter a valid web URL (http/https) or mobile custom URL (myapp://...)";
};

/**
 * Validates a single URL supporting both web URLs (http/https) and mobile custom schemes
 * 
 * @param url - Single URL to validate
 * @returns true if valid, false if invalid
 */
export const isValidUrl = (url: string): boolean => {
  return URL_VALIDATION_REGEX.test(url.trim());
};